export var buildFilterQuery = function (groups, selectedFilters, preFilter) {
    if (groups === void 0) { groups = []; }
    if (selectedFilters === void 0) { selectedFilters = []; }
    if (preFilter === void 0) { preFilter = ''; }
    var query = '';
    var filterGroupQuery = '';
    for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
        var group = groups_1[_i];
        var groupFilters = group.filters;
        var selectedGroupFilters = groupFilters.filter(function (loopFilter) { return selectedFilters.indexOf(loopFilter.id) > -1; });
        filterGroupQuery = '';
        selectedGroupFilters.forEach(function (filter) {
            filterGroupQuery += (filterGroupQuery === '' ? '' : ' or ') + filter.query;
        });
        if (filterGroupQuery === '') {
            continue;
        }
        if (query === '') {
            if (selectedGroupFilters.length === 1) {
                query += filterGroupQuery;
            }
            else {
                query += '(' + filterGroupQuery + ')';
            }
        }
        else {
            query += ' and (' + filterGroupQuery + ')';
        }
    }
    if (preFilter !== '' && query !== '') {
        query = preFilter + " and " + query;
    }
    else if (preFilter !== '' && query === '') {
        query = preFilter;
    }
    return query || '';
};
